/**
 * Tutorial guidato delle conversazioni WhatsApp.
 *
 * Un preparativo solo: la prima conversazione, che va aperta per mostrare la
 * risposta e la cronologia dei messaggi. `stopWhatsappTour` la richiude a fine giro,
 * ma solo se a spalancarla e' stato il tutorial.
 *
 * Il tutorial non tocca il pulsante Invia: quello manda un messaggio vero a un
 * numero vero, e un giro dimostrativo non deve poterlo fare. Il menu a tre puntini
 * si racconta illuminando il pulsante, senza aprirlo.
 */
const SCOPE = '[data-tour-scope="whatsapp"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let expandedRow = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre la conversazione della prima riga, se non ce n'e' gia' una aperta. */
function expandFirstRow() {
	if (visible(at('reply'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		expandedRow = true;
		toggle.click();
	}
}

/** Richiude la conversazione aperta dal tutorial. */
function collapseRow() {
	if (!expandedRow) return;

	expandedRow = false;

	if (visible(at('reply'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function stopWhatsappTour() {
	collapseRow();
}

export function createWhatsappTourSteps() {
	return [
		{
			body: "Qui arrivano le conversazioni WhatsApp del negozio: ogni riga e' il filo dei messaggi con un numero, non un singolo messaggio. Da questa pagina si legge quello che i clienti scrivono e si risponde.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le conversazioni WhatsApp',
		},
		{
			body: "Cerca nel numero o nel nome del contatto, da tre caratteri in su; si conferma con Invio o con la lente. Ricerca, pagina e ordinamento restano nell'indirizzo della pagina: un refresh riparte da li'.",
			key: 'search',
			placement: 'bottom',
			target: at('search'),
			title: 'Cercare una conversazione',
		},
		{
			body: "La tabella mostra la data dell'ultimo messaggio, il numero del contatto, il nome con cui si e' presentato, un'anteprima dell'ultimo messaggio, la lingua e quanti messaggi sono stati scambiati.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: 'I tre pallini a inizio riga raccolgono le azioni sulla conversazione: aprirla o chiuderla e copiare il numero del contatto.',
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Il menu della riga',
		},
		{
			body: "Il piu' accanto ai tre pallini apre la conversazione sotto la riga stessa: la cronologia completa e, in fondo, il riquadro per rispondere. Premila di nuovo per richiuderla.",
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			title: 'Aprire la conversazione',
		},
		{
			body: "Il riquadro della risposta: si scrive il messaggio, si sceglie il tipo - testo, immagine, video, audio o documento - e per tutto quello che non e' testo si allega il file con la graffetta. Il pulsante Invia, o il tasto Invio, chiede una conferma e poi manda il messaggio davvero: e' l'unico comando di questa pagina che esce dal gestionale, e un messaggio partito non si ritira.",
			before: expandFirstRow,
			key: 'reply',
			placement: 'top',
			target: at('reply'),
			timeout: 400,
			title: 'Rispondere',
		},
		{
			body: "Sopra il riquadro c'e' tutta la conversazione in ordine di tempo, con mittente, orario e stato di ogni messaggio - inviato, consegnato, letto. Immagini, audio e documenti si aprono direttamente da qui.",
			before: expandFirstRow,
			key: 'timeline',
			missing: 'skip',
			placement: 'top',
			target: at('timeline'),
			timeout: 400,
			title: 'La cronologia',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. L'ordinamento predefinito porta in cima le conversazioni con il messaggio piu' recente.",
			before: collapseRow,
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: 'Sfogliare le conversazioni',
		},
	];
}
